import CodeToolbarView from "./CodeToolbarView.vue";
import {Code as CodeExtension} from "@tiptap/extension-code";

export default class Code {

    constructor() {
        this.toolbarView = CodeToolbarView;
    }

    static create() {
        return new Code();
    }

    getExtensions() {
        return [CodeExtension];
    }
}